import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShellComponent } from './shell/shell.component';
import { CommonMaterialComponentsModule } from '@quorum/common-material-components';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DeclinedOpsCardComponent } from './declined-ops-card/declined-ops-card.component';
import { CommonPipesModule } from '@quorum/common-pipes';
import { NgPipesModule } from 'ngx-pipes';
import { ActionDeclinedOpDialogComponent } from './action-declined-ops-dialog/action-declined-ops-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    CommonMaterialComponentsModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    CommonPipesModule,
    NgPipesModule,
    FormsModule,
  ],
  declarations: [ShellComponent, DeclinedOpsCardComponent, ActionDeclinedOpDialogComponent],
  exports: [DeclinedOpsCardComponent, ActionDeclinedOpDialogComponent],
})
export class SvcDeclinedOpsNgUiModule {}
